module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.localCue && _vm.localCue.data) ? _c('tbody', {
    attrs: {
      "data-cue-id": _vm.localCue.id,
      "data-cue-parts": _vm.rowspan
    }
  }, _vm._l((_vm.rowspanArray), function(rowId, rowIndex) {
    return _c('tr', {
      key: rowIndex,
      class: {
        'even_color': _vm.isEven(_vm.cueIndex + 1)
      }
    }, [(rowIndex === 0) ? [_c('td', {
      staticClass: "ql-cell-empty ql-cell-select",
      attrs: {
        "rowspan": _vm.rowspan
      }
    }, [(_vm.editable) ? _c('md-checkbox', {
      attrs: {
        "value": _vm.selected
      },
      on: {
        "change": function (val) { return _vm.$emit('toggleSelect', _vm.localCue.id, val); }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "ql-cell-empty",
      class: {
        'ql-cell-attr-delete': _vm.editable
      },
      attrs: {
        "rowspan": _vm.rowspan
      },
      on: {
        "click": _vm.deleteCue
      }
    }, [(_vm.editable) ? _c('md-icon', [_vm._v("delete")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "ql-cell-text-center ql-cell-field-pageNumber",
      attrs: {
        "rowspan": _vm.rowspan,
        "title": _vm.jumpTooltip
      },
      on: {
        "click": _vm.switchViewToPage
      }
    }, [_vm._v(_vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[_vm.localCue.pageNumber - 1] &&
      _vm.project.pdfPageNumbers[_vm.localCue.pageNumber - 1].name && _vm.project.pdfPageNumbers[_vm.localCue.pageNumber - 1].name ? _vm.project.pdfPageNumbers[_vm.localCue.pageNumber - 1].name : _vm.localCue.pageNumber))]), _vm._v(" "), _c('td', {
      staticClass: "ql-cell-layer-color",
      style: (_vm.layerColor),
      attrs: {
        "rowspan": _vm.rowspan
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "ql-cell-field-layer",
      class: {
        'ql-cell-editable': _vm.editable
      },
      attrs: {
        "rowspan": _vm.rowspan
      }
    }, [(_vm.editable) ? _c('select', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localCueLayerId),
        expression: "localCueLayerId"
      }],
      attrs: {
        "tabindex": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.localCueLayerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.updateCueLayer]
      }
    }, 'select', _vm.qlAttrs('__layer__', null, 'select'), false), _vm._l((_vm.layerOptions), function(ll) {
      return _c('option', {
        key: ll.value,
        domProps: {
          "value": ll.value
        }
      }, [_vm._v(_vm._s(ll.text))])
    }), 0) : _c('div', _vm._l((_vm.viewLayersOtions), function(ll) {
      return _c('div', {
        key: ll.value,
        attrs: {
          "value": ll.value
        }
      }, [_vm._v(_vm._s(ll.value === _vm.localCueLayerId ? ll.text : ""))])
    }), 0)]), _vm._v(" "), _c('td', {
      staticClass: "ql-cell-field-title",
      class: {
        'ql-cell-editable': _vm.editable
      },
      attrs: {
        "rowspan": _vm.rowspan
      }
    }, [(_vm.editable) ? _c('div', _vm._b({
      staticClass: "ql-cell-editable-div",
      attrs: {
        "contenteditable": "",
        "tabindex": ""
      },
      domProps: {
        "textContent": _vm._s(_vm.localCue.title)
      },
      on: {
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.cancelEdit.apply(null, arguments)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.saveEdit('title', $event)
        }],
        "blur": function($event) {
          return _vm.stopEditFiled('title', $event)
        }
      }
    }, 'div', _vm.qlAttrs('title'), false)) : _c('div', {
      staticClass: "ql-cell-editable-div",
      attrs: {
        "tabindex": ""
      },
      domProps: {
        "textContent": _vm._s(_vm.localCue.title)
      }
    })])] : _vm._e(), _vm._v(" "), _vm._l((_vm.availableColumns), function(attr) {
      var _obj, _obj$1;

      return [(_vm.isPartsData(attr) && (attr !== 'user1' && attr !== 'user2' && attr !== 'user3' && attr !== 'user4')) ? _c('td', {
        key: attr + '_part_' + rowIndex,
        class: ( _obj = {}, _obj['sdfdsf ql-cell-attr-' + attr] = true, _obj['ql-cell-editable'] =  _vm.editable && _vm.localCue.layer.attributes[attr], _obj )
      }, [(_vm.localCue.data.parts) ? [(attr === 'parts_id') ? [(_vm.editable) ? _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        class: attr + '_' + rowIndex,
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data.partsData[rowIndex]['id'])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit('id', $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit('id', $event, rowIndex)
          }
        }
      }, 'div', _vm.qlAttrs('parts_id', rowIndex, 'text', 'id'), false)) : [_vm._v(_vm._s(_vm.localCue.data.partsData[rowIndex]['id'] || ''))]] : (attr === 'parts_label') ? [(_vm.editable) ? _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        class: attr + '_' + rowIndex,
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data.partsData[rowIndex]['label'])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit('label', $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit('label', $event, rowIndex)
          }
        }
      }, 'div', _vm.qlAttrs('parts_label', rowIndex, 'text', 'label'), false)) : [_vm._v(_vm._s(_vm.localCue.data.partsData[rowIndex]['label'] || ''))]] : _vm._e(), _vm._v(" "), (_vm.localCue.layer.attributes[attr] && _vm.editable) ? [(attr === 'mark') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.partsData[rowIndex].mark),
          expression: "localCue.data.partsData[rowIndex].mark"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data.partsData[rowIndex], "mark", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('mark', rowIndex, 'select'), false), _vm._l((['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']), function(mark, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": mark
          }
        }, [_vm._v(_vm._s(mark))])
      }), 0)] : _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        class: attr + '_' + rowIndex,
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data.partsData[rowIndex][attr])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit(attr, $event, rowIndex)
          }
        }
      }, 'div', _vm.qlAttrs(attr, rowIndex), false))] : [_vm._v(_vm._s(_vm.localCue.data.partsData[rowIndex][attr] || ''))]] : ((attr == 'user1' || attr == 'user2' || attr == 'user3' || attr == 'user4')) ? [(_vm.localCue.data[attr]) ? [(_vm.getUserDefined[attr].label) ? _c('b', {
        staticClass: "black"
      }, [_vm._v(_vm._s(_vm.getUserDefined[attr].label) + ": ")]) : _c('b', {
        staticClass: "gray"
      }, [_vm._v(_vm._s((attr.charAt(0).toUpperCase() + attr.slice(1))) + ": ")])] : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        class: attr + '_' + rowIndex,
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data[attr])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit(attr, $event)
          }
        }
      }, 'div', _vm.qlAttrs(attr), false)) : [_vm._v("\n                         " + _vm._s(_vm.localCue.data[attr] || '') + "\n                    ")]] : [(_vm.localCue.layer.attributes[attr] && _vm.editable) ? [(attr === 'mark') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.mark),
          expression: "localCue.data.mark"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "mark", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('mark', null, 'select'), false), _vm._l((['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']), function(mark, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": mark
          }
        }, [_vm._v(_vm._s(mark))])
      }), 0)] : _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data[attr])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit(attr, $event)
          }
        }
      }, 'div', _vm.qlAttrs(attr), false))] : [_vm._v(_vm._s(_vm.localCue.data[attr] || ''))]]], 2) : (rowIndex === 0 && (attr !== 'user1' && attr !== 'user2' && attr !== 'user3' && attr !== 'user4')) ? _c('td', {
        key: attr,
        class: ( _obj$1 = {}, _obj$1['iiiii ql-cell-attr-' + attr] = true, _obj$1['ql-cell-editable'] =  _vm.editable && _vm.localCue.layer.attributes[attr], _obj$1 ),
        attrs: {
          "rowspan": _vm.rowspan
        }
      }, [(attr === 'workNote' && _vm.notesListColumn) ? _c('div', {
        staticClass: "ql-noteslist-cell"
      }, [_c('span', {
        staticClass: "ql-noteslist-slot"
      }, [_c('button', {
        staticClass: "ql-noteslist-add",
        attrs: {
          "type": "button",
          "aria-label": "Add Note in The Notes List"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.openNotesListAddNote.apply(null, arguments)
          }
        }
      }, [_c('img', {
        staticClass: "ql-noteslist-add-icon",
        attrs: {
          "src": _vm.noteslistNoteIconSrc,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "ql-noteslist-add-icon ql-noteslist-add-icon--hover",
        attrs: {
          "src": _vm.noteslistNoteIconHoverSrc,
          "alt": ""
        }
      }), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Add Note in The Notes List")])], 1), _vm._v(" "), (_vm.notesListOpen) ? _c('span', {
        staticClass: "ql-noteslist-count",
        attrs: {
          "title": _vm.notesListOpen + (_vm.notesListOpen === 1 ? ' open note' : ' open notes') + ' in The Notes List'
        }
      }, [_c('svg', {
        staticClass: "ql-noteslist-count-mark",
        attrs: {
          "viewBox": "0 0 256 256",
          "aria-hidden": "true",
          "focusable": "false"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M218.29,182.17a12,12,0,0,1-16.47,4.12L140,149.19V216a12,12,0,0,1-24,0V149.19l-61.82,37.1a12,12,0,1,1-12.35-20.58L104.68,128,41.83,90.29A12,12,0,1,1,54.18,69.71L116,106.81V40a12,12,0,0,1,24,0v66.81l61.82-37.1a12,12,0,1,1,12.35,20.58L151.32,128l62.85,37.71A12,12,0,0,1,218.29,182.17Z"
        }
      })]), _vm._v(_vm._s(_vm.notesListOpen) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (_vm.leftoverWorkNote !== null) ? _c('span', {
        staticClass: "ql-noteslist-leftover"
      }, [_c('span', {
        staticClass: "ql-noteslist-leftover-tag"
      }, [_vm._v("Cuelist work note")]), _vm._v(" "), _c('span', {
        staticClass: "ql-noteslist-leftover-text"
      }, [_vm._v(_vm._s(_vm.leftoverWorkNote))]), _vm._v(" "), (_vm.editable) ? _c('md-button', {
        staticClass: "md-icon-button btn-archive-cue",
        on: {
          "click": function($event) {
            return _vm.archivedWorkNote(_vm.leftoverWorkNote, $event)
          }
        }
      }, [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Archive note")])], 1) : _vm._e(), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Read-only on a show linked to The Notes List. Archive it when you're done with it.")])], 1) : _vm._e()]) : ((_vm.localCue.layer.attributes[attr] || attr === 'workNote') && _vm.editable) ? [(attr === 'parts') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.parts),
          expression: "localCue.data.parts"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "parts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.partsChanged]
        }
      }, 'select', _vm.qlAttrs('parts', null, 'select'), false), _vm._l((['', 2, 3, 4, 5, 6, 7, 8]), function(part, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": part
          }
        }, [_vm._v(_vm._s(part))])
      }), 0)] : (attr == 'block') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.block),
          expression: "localCue.data.block"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "block", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('block', null, 'select'), false), _vm._l((['', 'B', 'I', 'b']), function(block, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": block
          }
        }, [_vm._v(_vm._s(block))])
      }), 0)] : (attr == 'assert') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.assert),
          expression: "localCue.data.assert"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "assert", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('assert', null, 'select'), false), _vm._l((['', 'A', 'a']), function(assert, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": assert
          }
        }, [_vm._v(_vm._s(assert))])
      }), 0)] : (attr === 'followHang') ? [_c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center",
          "gap": "6px"
        }
      }, [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.followHangType),
          expression: "localCue.data.followHangType"
        }],
        staticStyle: {
          "flex": "0 0 auto"
        },
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "followHangType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('followHang', null, 'select', 'followHangType'), false), _vm._l((['', 'F', 'H']), function(fh, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": fh
          }
        }, [_vm._v(_vm._s(fh))])
      }), 0), _vm._v(" "), _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        staticStyle: {
          "flex": "1 1 auto",
          "min-width": "0"
        },
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data.followHang)
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit(attr, $event)
          }
        }
      }, 'div', _vm.qlAttrs('followHang', null, 'text', 'followHang'), false))])] : (attr == 'consumable') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.consumable),
          expression: "localCue.data.consumable"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "consumable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('consumable', null, 'select'), false), _vm._l((['N', 'Y']), function(consumable, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": consumable
          }
        }, [_vm._v(_vm._s(consumable))])
      }), 0)] : (attr == 'rehearsal') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.rehearsal),
          expression: "localCue.data.rehearsal"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "rehearsal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('rehearsal', null, 'select'), false), _vm._l((['N', 'Y']), function(rehearsal, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": rehearsal
          }
        }, [_vm._v(_vm._s(rehearsal))])
      }), 0)] : (attr == 'actual') ? [_c('select', _vm._b({
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localCue.data.actual),
          expression: "localCue.data.actual"
        }],
        attrs: {
          "tabindex": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.localCue.data, "actual", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, _vm.updateCue]
        }
      }, 'select', _vm.qlAttrs('actual', null, 'select'), false), _vm._l((['N', 'Y']), function(actual, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": actual
          }
        }, [_vm._v(_vm._s(actual))])
      }), 0)] : (attr == 'workNote') ? [_c('div', {
        staticClass: "ql-cell-attr-workNote-content"
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex"
        }
      }, [_c('div', [_c('md-button', {
        staticClass: "md-icon-button md-dense btn-toggle-workNote",
        class: {
          'workNote-marked': _vm.isActveWorkNote
        },
        attrs: {
          "tabindex": ""
        },
        on: {
          "click": _vm.toggleWorkNote
        }
      }, [_c('md-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.isActveWorkNote),
          expression: "!isActveWorkNote"
        }]
      }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isActveWorkNote),
          expression: "isActveWorkNote"
        }]
      }, [_vm._v("check_box")]), _vm._v(" "), _c('md-tooltip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.isActveWorkNote),
          expression: "!isActveWorkNote"
        }],
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Check or write text to add work note")]), _vm._v(" "), _c('md-tooltip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isActveWorkNote),
          expression: "isActveWorkNote"
        }],
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Uncheck to delete note without archiving")])], 1)], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('div', {
        staticClass: "note-item"
      }, [_c('div', _vm._b({
        ref: "ql-cell-attr-workNote ff",
        refInFor: true,
        staticClass: "ql-cell-editable-div",
        attrs: {
          "contenteditable": "",
          "tabindex": "",
          "id": 'ql-cell-attr-workNote' + _vm.localCue.id
        },
        domProps: {
          "textContent": _vm._s(_vm.workingNote ? _vm.workingNote : '')
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.saveWorkNote($event)
          }
        }
      }, 'div', _vm.qlAttrs('workNote'), false)), _vm._v(" "), (_vm.workingNote) ? _c('md-button', {
        staticClass: "md-icon-button btn-archive-cue",
        on: {
          "click": function($event) {
            return _vm.archivedWorkNote(_vm.workingNote, $event)
          }
        }
      }, [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top"
        }
      }, [_vm._v("Archive note")])], 1) : _vm._e()], 1)])])] : _c('div', _vm._b({
        staticClass: "ql-cell-editable-div",
        attrs: {
          "contenteditable": "",
          "tabindex": ""
        },
        domProps: {
          "textContent": _vm._s(_vm.localCue.data[attr])
        },
        on: {
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelEdit.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.saveEdit(attr, $event)
          }],
          "blur": function($event) {
            return _vm.stopEdit(attr, $event)
          }
        }
      }, 'div', _vm.qlAttrs(attr), false))] : [((attr === 'workNote')) ? _c('div', _vm._l((_vm.localCue.data[attr]), function(item, index) {
        return _c('div', {
          key: index
        }, [(!item.archived) ? _c('div', [_vm._v("\n                                " + _vm._s(item.note) + "\n                            ")]) : _vm._e()])
      }), 0) : (attr === 'followHang') ? _c('div', [_vm._v("\n                        " + _vm._s((_vm.localCue.data.followHangType || '') + (_vm.localCue.data.followHang || '')) + "\n                    ")]) : _c('div', [_vm._v("\n                        " + _vm._s(_vm.localCue.data[attr]) + "\n                    ")])]], 2) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.layerUserDefined), function(layer) {
      return [_vm._l((layer.userDefined), function(ud, ui) {
        var _obj;

        return [(rowIndex === 0 && layer.id === _vm.localCueLayerId) ? _c('td', {
          key: ui + '_userDefined_' + layer.id,
          class: ( _obj = {}, _obj['ql-cell-attr-' + ui] = true, _obj['ql-cell-editable'] =  _vm.editable && _vm.localCue.layer.attributes[ui], _obj ),
          attrs: {
            "rowspan": _vm.rowspan
          }
        }, [(_vm.editable) ? [(_vm.editable && _vm.localCue && _vm.localCue.layer && _vm.localCue.layer.userDefined && !_vm.localCue.layer.userDefined[ui].value) ? _c('div', {
          class: ui + '_' + rowIndex,
          attrs: {
            "contenteditable": "false"
          },
          domProps: {
            "textContent": _vm._s(_vm.localCue.data[ui])
          }
        }) : _c('div', _vm._b({
          staticClass: "ql-cell-editable-div",
          class: ui + '_' + rowIndex,
          attrs: {
            "contenteditable": "",
            "tabindex": ""
          },
          domProps: {
            "textContent": _vm._s(_vm.localCue.data[ui])
          },
          on: {
            "keydown": [function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
              return _vm.cancelEdit.apply(null, arguments)
            }, function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.saveEdit(ui, $event)
            }],
            "blur": function($event) {
              return _vm.stopEdit(ui, $event)
            }
          }
        }, 'div', _vm.qlAttrs(ui), false))] : [_vm._v("\n                       " + _vm._s(_vm.localCue.data[ui]) + "\n                    ")]], 2) : (rowIndex === 0) ? _c('td', [_c('span', [_vm._v("-")])]) : _vm._e()]
      })]
    })], 2)
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8f8d006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/list-view/cell-row.vue
// module id = 1296
// module chunks = 21